import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminShippingMethodContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;
}
